import React from 'react';
import blendProcess from '../config/blend-process-content.json';
import './HowItWorks.css';

/**
 * Quiet three-beat journey under the hero — matches current DIY flow
 * (capacity marks + compose + craft), not the old “must pick a foundation” story.
 */
function HowItWorks() {
  const { steps } = blendProcess;

  return (
    <ol className="blend-journey" aria-label="How custom blending works">
      {steps.map((step, index) => (
        <li key={step.id} className="blend-journey__beat">
          {index > 0 && (
            <span className="blend-journey__rule" aria-hidden="true" />
          )}
          <span className="blend-journey__label">{step.label}</span>
          <span className="blend-journey__body">{step.body_home}</span>
        </li>
      ))}
    </ol>
  );
}

export default HowItWorks;
